import axios from 'axios';
import { getToken, createApiUrl } from '../../util';
import api from 'api/axiosInstance';
import { FacetEditShadingStatus, normalizeFacetShadingStatus } from 'api/editDsm';

// Resolves to the reshade the switch made necessary (if any), like switchDesignMode.
export async function switchDesignImagery(input: { source: string, uuid: string, panelKey: string }): Promise<FacetEditShadingStatus | undefined> {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const apiUrl = '/designs/switch-design-source/';
	const { data } = await api.patch(createApiUrl(apiUrl), input, config);
	return normalizeFacetShadingStatus(data);
}

export async function switchRoofDesignImagery(input: { source: string, uuid: string, panelKey: string }) {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const apiUrl = '/designs/roof/switch-design-source/';
	await api.patch(createApiUrl(apiUrl), input, config);
	return true;
}